(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nf-mirror-preview"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nf-mirror-preview')) {
  customElements.define('nf-mirror-preview', class extends HTMLElement {
    connectedCallback() {
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.fields = this.closest('.nf-personalization');
        this.form = this.closest('form');
        if (!this.fields || !this.form) return;
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.fields.addEventListener('input', event => {
          if (!event.target.closest('[data-mirror-row]')) return;
          this.updatePreview();
          this.clearConfirmation();
        }, { signal });
        this.form.addEventListener('nf:bundle-change', () => this.syncQuantity(), { signal });
        this.form.addEventListener('change', () => this.syncQuantity(), { signal });
        this.form.addEventListener('input', event => {
          if (event.target.name === 'quantity') this.syncQuantity();
        }, { signal });
        this.form.addEventListener('reset', () => requestAnimationFrame(() => this.syncQuantity()), { signal });
        this.syncQuantity();
      });
    }
    disconnectedCallback() {
      this.controller?.abort();
    }
    clearConfirmation() {
      const confirmation = this.fields.querySelector('input[data-personalization-confirm]');
      if (confirmation) confirmation.checked = false;
    }
    syncQuantity() {
      const count = Math.max(1, Math.floor(Number(this.form.querySelector('input[name="quantity"]')?.value) || 1));
      if (this.count !== undefined && this.count !== count) this.clearConfirmation();
      this.count = count;
      let rows = [...this.fields.querySelectorAll('[data-mirror-row]')];
      let arts = [...this.querySelectorAll('[data-mirror-art]')];
      for (let index = rows.length + 1; index <= count; index++) {
        const row = rows[0].cloneNode(true);
        row.dataset.mirrorRow = String(index);
        row.querySelector('.nf-personalization-row-title').textContent = this.dataset.mirrorLabel.replace('[number]', index);
        row.querySelectorAll('input').forEach((input, fieldIndex) => {
          const oldId = input.id;
          input.id = oldId + '-mirror-' + index;
          row.querySelectorAll('label').forEach(label => { if (label.htmlFor === oldId) label.htmlFor = input.id; });
          input.name = 'properties[' + this.dataset.mirrorLabel.replace('[number]', index) + ' - ' + (fieldIndex === 0 ? this.dataset.propertyName : this.dataset.propertyNumber) + ']';
          input.value = '';
        });
        rows[rows.length - 1].after(row);
        rows.push(row);
        const art = arts[0].cloneNode(true);
        art.dataset.mirrorArt = String(index);
        art.querySelector('figcaption').textContent = this.dataset.mirrorLabel.replace('[number]', index);
        const ids = [...art.querySelectorAll('[id]')].map(element => element.id);
        art.querySelectorAll('*').forEach(element => {
          for (const attr of [...element.attributes]) {
            let value = attr.value;
            for (const id of ids) value = value.replaceAll(id, id + '-mirror-' + index);
            if (value !== attr.value) element.setAttribute(attr.name, value);
          }
        });
        this.querySelector('.nf-mirror-preview__grid').append(art);
        arts.push(art);
      }
      rows.forEach((row, index) => {
        row.hidden = index >= count;
        row.querySelector('.nf-personalization-row-title').hidden = count === 1;
        row.querySelectorAll('input').forEach(input => { input.disabled = index >= count; input.required = index < count; });
      });
      arts.forEach((art, index) => {
        art.hidden = index >= count;
        art.querySelector('figcaption').hidden = count === 1;
      });
      this.style.setProperty('--mirror-columns', String(Math.min(count, 3)));
      this.updatePreview();
    }
    updatePreview() {
      let hasValue = false;
      this.fields.querySelectorAll('[data-mirror-row]').forEach((row, index) => {
        if (row.hidden) return;
        const inputs = row.querySelectorAll('input');
        const name = inputs[0].value.trim();
        const number = inputs[1].value.trim();
        const art = this.querySelector('[data-mirror-art="' + (index + 1) + '"]');
        if (!art) return;
        const nameText = art.querySelector('[data-preview-name]');
        nameText.textContent = name || this.dataset.emptyName;
        art.querySelector('[data-preview-number]').textContent = /^[0-9]{1,2}$/.test(number) ? number : this.dataset.emptyNumber;
        nameText.setAttribute('font-size', '48');
        const width = nameText.getComputedTextLength();
        if (width > 195) nameText.setAttribute('font-size', String(48 * 195 / width));
        hasValue ||= Boolean(name || number);
      });
      this.querySelector('[data-preview-hint]').hidden = hasValue;
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nf-personalization"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
 const form = event.target;
 if (!(form instanceof HTMLFormElement)) return;
 const fields = form.querySelector('.nf-personalization');
 if (!fields) return;
 const name = fields.querySelector('input[data-personalization-name]');
 if (name) name.value = name.value.trim();
 fields.querySelectorAll('[data-mirror-row] input[type="text"]').forEach(input => { input.value = input.value.trim(); });
 if (!form.checkValidity()) {
  event.preventDefault();
  event.stopImmediatePropagation();
  form.reportValidity();
 }
}, true);
  } catch(e) { console.error(e); }
})();

})();
